var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.04,
    height: 29.391,
    viewBox: "0 0 29.04 29.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-chat-4869855",
    transform: "translate(-0.918 -0.648)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M28.284,22.307A14.464,14.464,0,0,0,29.8,13.392a14.491,14.491,0,1,0-28.77,3.5,14.569,14.569,0,0,0,12.229,13,15.555,15.555,0,0,0,2.235.145,14.319,14.319,0,0,0,6.719-1.67l3.879,1.039a2.63,2.63,0,0,0,3.222-3.222Zm-7.534-2.788H10.23a1.315,1.315,0,1,1,0-2.63H20.749a1.315,1.315,0,1,1,0,2.63Zm0-5.26H10.23a1.315,1.315,0,1,1,0-2.63H20.749a1.315,1.315,0,1,1,0,2.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0315f1f4d1cff1b8e3a329057473b1bf.svg";
export { ForwardRef as ReactComponent };